import React, { Fragment, memo, useEffect, useState } from "react";
import styles from "../../assets/scss/authentication.module.scss";
import cx from "classnames";
import { Alert, Button, Form, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { isValidPhoneNumber } from "react-phone-number-input";
import OTP from "./OTP";
import MobileInput from "./MobileInput";
import { CLEAR_AUTHENTICATION_DATA, SEND_OTP } from "../../actions/types";
import NeedHelpModal from "../NeedHelpModal";
import {
  calcInputSize,
  getGeolocation,
  isValidEmail,
  reloadPage,
} from "../../utilities";
import ModalBox from "../common/ModalBox.js";
import FloatLabelInput from "../common/FloatLabelInput.js";
import { MailOutlined } from "@ant-design/icons";
import { MdCall, MdOutlineAlternateEmail } from "react-icons/md";
import { SUPER_SIMPLE_AUTH_ORG_IDS } from "../../services/environments.js";
import { AppLocalStorage, AppStorageKeys } from "../../services/contracts.js";

const FormItem = Form.Item;

function Login(props) {
  const {
    isAuthSwitched,
    closeAuth,
    formsData,
    setFormsData,
    usingViaEmail,
    setUsingViaEmail,
    email,
    setEmail,
  } = props;
  const { domainDetails } = useSelector((state) => state.listings);
  const [showOtp, setShowOtp] = useState(false);
  const [isResendOtp, setIsResendOtp] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const authentications = useSelector((state) => state.authentications);
  const [showLoginError, setShowLoginError] = useState(false);
  const [emailError, setEmailError] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    setShowLoginError(false);
    if (
      authentications &&
      authentications.login &&
      authentications.login.status === "BAD_REQUEST"
    ) {
      if (showLoginError) {
        return false;
      } else {
        setShowLoginError(true);
      }
    }
    if (
      (authentications &&
        authentications.login &&
        !authentications.login.newUser &&
        authentications.login.status === "OK") ||
      isResendOtp
    ) {
      if (!checkForNonSimpleAuthOrgId() && authentications.login.accessToken) {
        AppLocalStorage.save(
          AppStorageKeys.userAccessToken,
          authentications.login.accessToken
        );
        closeAuth();
        reloadPage();
      } else {
        setShowOtp(true);
      }
    } else {
      setShowOtp(false);
    }
    if (
      authentications &&
      authentications.login &&
      authentications.login.newUser
    ) {
      isAuthSwitched(true);
    }
  }, [authentications]);

  const sendOtp = () => {
    if (usingViaEmail && onEmailBlur()) {
      return;
    }
    dispatch({
      type: SEND_OTP,
      payload: usingViaEmail
        ? {
            email: email,
            site:
              domainDetails && domainDetails.orgType === "certifier"
                ? "microsite"
                : "docpro",
            organizationId: domainDetails.id,
            skipOtp: !checkForNonSimpleAuthOrgId(),
          }
        : {
            mobileNumber: authentications.mobileDetails.nationalNumber,
            site:
              domainDetails && domainDetails.orgType === "certifier"
                ? "microsite"
                : "docpro",
            countrySortName: authentications.mobileDetails.country,
            organizationId: domainDetails.id,
            skipOtp: !checkForNonSimpleAuthOrgId(),
          },
    });
  };

  const changeNumber = (value) => {
    isAuthSwitched(value);
    setIsResendOtp(value);
  };

  const handleLogin = () => {
    sendOtp();
    const { latitude, longitude } = getGeolocation();
    const payload = {
      LOCATION: { latitude: latitude, longitude: longitude },
    };
  };

  const checkForNonSimpleAuthOrgId = () => {
    return !SUPER_SIMPLE_AUTH_ORG_IDS.includes(domainDetails.id);
  };

  const validateAndHandleLogin = () => {
    if (
      authentications &&
      authentications.mobileDetails &&
      isValidPhoneNumber(authentications.mobileDetails.number + "")
    ) {
      handleLogin();
    }
  };

  const handleLoginErrorModalClose = () => {
    dispatch({
      type: CLEAR_AUTHENTICATION_DATA,
    });
    setShowLoginError(false);
  };

  const onEmailBlur = () => {
    if (email && !isValidEmail(email)) {
      setEmailError("Please enter a valid email address!");
      return true;
    } else if (!email) {
      setEmailError("Please enter your email address!");
      return true;
    } else {
      setEmailError("");
    }
    return false;
  };

  const validateSignUpFields = () => {
    return false;
  };

  const onChange = (value, name) => {
    setFormsData({ ...formsData, [name]: value });
  };

  const handleToggleVia = () => {
    setUsingViaEmail(!usingViaEmail);
  };

  return (
    <Fragment>
      <NeedHelpModal visible={isModalVisible} setVisible={setIsModalVisible} />
      {!showOtp ? (
        <div className={styles.auth_flex}>
          <div id="login_forms" className={styles.form_container_mobile}>
            <h1 className={styles.auth_heading}>Login</h1>
            <p className={styles.info_text}>
              or{" "}
              <span
                onClick={() => {
                  isAuthSwitched(true);
                }}
                className={styles.linkButton}
              >
                create an account
              </span>
            </p>
            {authentications?.mobileDetails?.country !== "IN" && (
              <Alert
                message="OTP will be sent to your registered email."
                type="warning"
                showIcon
                style={{ marginBottom: 24 }}
              />
            )}
            {usingViaEmail ? (
              <FloatLabelInput
                label="Email Address *"
                name="email"
                value={email}
                className="email-control"
              >
                <FormItem
                  validateStatus={emailError || !email ? "error" : "success"}
                  help={emailError ? emailError : !email ? emailError : ""}
                >
                  <Input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    size={calcInputSize}
                    allowClear
                    autoComplete="none"
                    prefix={
                      <div className="prefix">
                        <MailOutlined />
                      </div>
                    }
                  />
                </FormItem>
              </FloatLabelInput>
            ) : (
              <MobileInput
                location="login"
                validateAndHandleLogin={validateAndHandleLogin}
              />
            )}
            {(authentications &&
              authentications.status === "success" &&
              authentications.checkMobile.isUser === "newUser") ||
            (authentications &&
              authentications.login &&
              authentications.login.newUser) ? (
              <Alert
                message={
                  authentications.checkMobile.message ||
                  authentications.login.message
                }
                type="info"
                showIcon
                className={styles.mt_5}
              />
            ) : null}
            <button
              onClick={handleLogin}
              block
              key={authentications}
              disabled={
                !!(
                  (!usingViaEmail &&
                    authentications &&
                    authentications.mobileDetails &&
                    !isValidPhoneNumber(
                      authentications.mobileDetails.number + ""
                    )) ||
                  validateSignUpFields()
                )
              }
              className={styles.authButton}
              loading={
                authentications.status === "fetching" ||
                authentications.status === "checking"
                  ? true
                  : false
              }
            >
              CONTINUE
            </button>
            <div
              className={
                "font-size-10 font-bold-500 font-black text-center mt-16 mb-4 or-divider"
              }
            >
              <span
                className={
                  "relative zIndex-1 inline-flex items-center jc-center width-24 height-24 rounded-24"
                }
                style={{ background: "#cfcfcf" }}
              >
                Or
              </span>
            </div>
            <div className={"font-size-14 font-grey text-center mt-16 mb-16"}>
              Connect using with
            </div>
            <div className={"flex items-center jc-center"}>
              <button
                onClick={handleToggleVia}
                className={
                  "bg-transparent rounded-6 border-1 border-black-5 height-40 min-width-175 xs-min-width-160 flex items-center jc-center ml-8 xs-ml-4 mr-8 xs-mr-4 pl-16 xs-pl-6 pr-16 xs-pr-6 hovered-button o-hidden"
                }
                style={{ marginTop: 0 }}
              >
                {usingViaEmail ? (
                  <MdCall className={"mr-8 font-size-24 font-color-orange"} />
                ) : (
                  <MdOutlineAlternateEmail
                    className={"mr-8 font-size-24 font-color-orange"}
                  />
                )}
                <span className={"font-size-14 font-black default-line"}>
                  {usingViaEmail ? "Mobile Number" : "Email Address"}
                </span>
              </button>
            </div>
            {(domainDetails?.domainName === "rochewomenhealth" ||
              domainDetails?.domainName === "diabetesheartconnect") && (
              <p style={{ marginTop: 20, textAlign: "center", fontSize: 13 }}>
                By clicking 'Continue', you agree to share your contact details
                with Roche to receive further information
              </p>
            )}
            <p className={cx(styles.trouble_box)}>
              Trouble signing in?{" "}
              <span
                className={styles.linkButton}
                onClick={() => setIsModalVisible(true)}
              >
                Click here
              </span>
            </p>
          </div>
          {/* <div className={styles.agreement_box}>
            <span>
              By clicking the button above I accept the{' '}
              <a href='/terms-of-use' className={styles.linkButton}>
                Terms of Use
              </a>{' '}
              and{' '}
              <a href='/privacy-policy' className={styles.linkButton}>
                Privacy Policy
              </a>{' '}
              of Omnicuris{authentications.mobileDetails.country !== 'IN' ? '' : ' & I opt-in to receive updates on WhatsApp'}.
            </span>
          </div> */}
        </div>
      ) : (
        <OTP
          number={authentications && authentications.mobileDetails}
          email={
            email
              ? email
              : authentications &&
                authentications.login &&
                authentications.login.registeredEmail
          }
          closeAuth={closeAuth}
          changeNumber={changeNumber}
          setIsResendOtp={setIsResendOtp}
          changeNumberFor="login"
          usingViaEmail={usingViaEmail}
        />
      )}

      <ModalBox
        title={null}
        visible={showLoginError}
        setVisible={handleLoginErrorModalClose}
      >
        <div className="flex fd-column items-center jc-center ">
          <h5 className="text-center font-size-18">
            {authentications &&
              authentications.login &&
              (authentications.login.message || authentications.login.Message)}
          </h5>
          <Button
            type={"primary"}
            className={"mt-16"}
            onClick={handleLoginErrorModalClose}
          >
            OK
          </Button>
        </div>
      </ModalBox>
    </Fragment>
  );
}

export default memo(Login);
